export default __webpack_public_path__ + "static/media/software.86247a4f.jpg";